module.exports = __webpack_public_path__ + "static/img/dynamick.012b094.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamick.png
// module id = JLh3
// module chunks = 45